import { useMutation } from "@tanstack/react-query";
import { HiverAxios, sendExceptionToSentry } from "h-commons";

const SEND_FEEDBACK_QUERY_KEY = "SEND_FEEDBACK_QUERY_KEY";

const sendPlgFeedbackApi = async (payload) => 
  new Promise((resolve, reject) => {
    HiverAxios({
      url: "/gx/ext/plg-feedback",
      type: "POST",
      params: payload,
      callback: (response) => {
        const { data, status } = response;
        if (status === 200 && data?.status === "success") {
          resolve({ success: true });
        } else {
          reject({ status: false });
        }
      },
      onfail: (error) => {
        reject({ success: false });
        sendExceptionToSentry(error);
      },
    });
  });

export const usePlgFeedbackMutation = (extraQueyKeyParams = []) => {
  return useMutation({
    mutationKey: [SEND_FEEDBACK_QUERY_KEY, ...extraQueyKeyParams],
    mutationFn: sendPlgFeedbackApi,
  });
};
